var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckRounded = function SvgCheckRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 3.00002L3.16634 5.08335L7.33301 0.916687",
    stroke: "#0F6991",
    strokeWidth: 1.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCheckRounded;